import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const LIST_PROMOTION_CODES_FAIL =
  "PROMOTION-CODE:LIST_PROMOTION_CODES_FAIL";

export interface ListPromotionCodesFailAction extends Action {
  type: typeof LIST_PROMOTION_CODES_FAIL;
  organization: OrganizationKeyName;
}

export const listPromotionCodesFailAction = (
  organization: OrganizationKeyName
): ListPromotionCodesFailAction => ({
  type: LIST_PROMOTION_CODES_FAIL,
  organization,
});
